import { useState, useRef, useEffect } from 'react'
import { ChatMessage } from '@portfolio/shared'
import ChatMessages from './ChatMessages'
import ChatInput from './ChatInput'
import SuggestedQuestions from './SuggestedQuestions'

interface ChatSectionProps {
  messages: ChatMessage[]
  onSendMessage: (message: string) => void
  isLoading: boolean
}

export default function ChatSection({ messages, onSendMessage, isLoading }: ChatSectionProps) {
  const [showSuggestions, setShowSuggestions] = useState(messages.length === 0)
  const messagesEndRef = useRef<HTMLDivElement>(null)

  const suggestedQuestions = [
    "どんな技術スタックが得意ですか？",
    "これまでで一番苦労したプロジェクトは？",
    "フロントエンドとバックエンド、どちらが好きですか？",
    "チーム開発での役割は？",
    "今後学びたい技術は？"
  ]

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [messages])

  useEffect(() => {
    setShowSuggestions(messages.length === 0)
  }, [messages.length])

  const handleSuggestionClick = (question: string) => {
    onSendMessage(question)
    setShowSuggestions(false)
  }

  return (
    <div className="animate-slide-up">
      <div className="mb-4 sm:mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-white mb-2">
          質問してみてください
        </h2>
        <p className="text-sm sm:text-base text-gray-300">
          技術的なことから個人的なことまで、何でもお聞きください。
        </p>
      </div>

      {showSuggestions && (
        <SuggestedQuestions 
          questions={suggestedQuestions}
          onQuestionClick={handleSuggestionClick}
        />
      )}

      <div className="space-y-4 mb-4 sm:mb-6 max-h-64 sm:max-h-96 overflow-y-auto scrollbar-hide">
        <ChatMessages messages={messages} />
        {isLoading && (
          <div className="flex items-center space-x-2 text-gray-300">
            <div className="animate-pulse-slow text-sm sm:text-base">考えています...</div>
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>

      <ChatInput onSendMessage={onSendMessage} isLoading={isLoading} />
    </div>
  )
}